import HeaderQuoteBar from '../../../molecules/profile/header-quote-bar';
import PageHeader from '../../../molecules/profile/page-header';
import PageMain from '../../../molecules/profile/page-main';

const Loading = () => {
  return (
    <div data-template="Loading">
      <PageHeader fundName={null}>
        <HeaderQuoteBar />
      </PageHeader>
      <PageMain />
    </div>
  );
};

export default Loading;
